import { generateMutations } from '../builder'

export default {
  ...generateMutations('getLiteraryPrizes', 'literaryPrizes'),
  ...generateMutations('getLiteraryPrize', 'literaryPrize'),
  ...generateMutations('saveLiteraryPrize', 'literaryPrize'),
  ...generateMutations('deleteLiteraryPrize'),
}
